import { memo, useState } from 'react';

import Link from 'next/link';

import { useAppSelector } from '@shared/hooks/redux';
import { ProductCardType } from '@shared/types/product';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';
import { Slider } from '@widgets/ProductCard/ui/Slider/Slider';

import cls from './ProductImages.module.scss';

type ProductImagesProps = Pick<ProductCardType, 'images' | 'url' | 'advantages'> & { productName: string };

export const ProductImages = memo<ProductImagesProps>(({ images = [], url = '', productName, advantages }) => {
  const [hover, setHover] = useState(false);

  const viewPort = useAppSelector(getViewPort);

  const notDesktop = viewPort !== 'desktop';

  const mouseOnHaler = () => {
    if (notDesktop) return;
    setHover(true);
  };

  const mouseLeaveHandler = () => {
    if (notDesktop) return;
    setHover(false);
  };

  return (
    <Link
      className={cls.wrapper}
      onMouseLeave={mouseLeaveHandler}
      onMouseOver={mouseOnHaler}
      href={url}
    >
      {images.length > 0 ? (
        <Slider
          className={cls.sliderWrapper}
          swiperClassName={cls.slider}
          controlsClassName={cls.sliderControls}
          dotClassName={cls.sliderDot}
          dotActiveClassName={cls.sliderDotActive}
          advantagesClassName={cls.advantages}
          variant={'card'}
          slides={images}
          hovered={hover}
          productName={productName}
          advantages={advantages}
        />
      ) : (
        <div className={cls.empty}>нет фото</div>
      )}
    </Link>
  );
});
